<template>
  <div>
    <div class="anchor-style" v-for="(anchor,i) in anchors" :key="i">
      <p class="anchor-class ml-4">{{anchor.anchorvalue}}</p>
      <a :class="anchor.isAnchorDot ? 'aClass ml-1':'aClass ml-4'" @click="goToAnchorPage($event)">
        <span :class="anchor.anchorDotClass" v-if="anchor.isAnchorDot"></span>
        {{$t(anchor.anchorText)}}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: ["anchors"],
  created() {},
  methods: {
    goToAnchorPage(event) {
      this.$emit("anchorClickEvent", event.target.innerText);
    }
  }
};
</script> 

<style scoped>
.anchor-style {
  display: inline-block;
  margin-right: 45px;
}
.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
}
.dot-green {
  background-color: #28b915;
}
.dot-red {
  background-color: #e61313;
}
.dot-blue {
  background-color: #002d72;
}
.dot-yellow {
  background-color: #f4cf08;
}
.anchor-class {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 44px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: #333333;
  margin-bottom: 0px !important;
}
.aClass {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: center;
  color: #333333;
  float: left;
  text-decoration: underline !important;
  cursor: pointer;
}
@media (max-width: 1350px) {
  .anchor-style {
    margin-right: 18px;
  }
}
@media (max-width: 1090px) {
  .anchor-style {
    margin-right: 9px;
  }
}
</style>
